<template>
  <div class="v-atlas-ikm-feature-info">
    <TabsGroup class="x-auto-expand">
      <!--#region Data table tab-->
      <Tab label="Datentabelle" tab-key="list">
        <div class="c-padded">
          <template v-if="districtsData">
            <table class="ikm-districts-table">
              <thead>
                <tr>
                  <th>Kreis</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="feature in sortedDistricts" :key="feature.properties?.id">
                  <td>{{ feature.properties?.name }}</td>
                  <td>
                    {{ feature.properties?.[props.mapModule.reactiveData.requestSettings.attrName]
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </template>
        </div>
      </Tab>
      <!--#endregion Data table tab-->

      <!--#region Options tab-->
      <Tab label="Optionen" tab-key="settings">
        <div class="c-padded">
          <!-- Placeholder -->
          Hier ist erst mal nichts
        </div>
      </Tab>
      <!--#endregion Options tab-->
    </TabsGroup>

    <LoadingIndicatorOverlay v-if="isLoadingDelayed" />
  </div>
</template>

<script setup lang="ts">
import { computed, onUnmounted } from "vue";
import { useDelayedBoolean, useSmartFetch, LoadingIndicatorOverlay, Tab, TabsGroup } from "gertrud";
import { IkmMapModule } from "./IkmMapModule";
import { IkmGeoJsonResponse } from "atlas-shared";


const props = defineProps<{
  regionId: string
  mapModule: IkmMapModule
}>()

const districtsUrl = computed(() => {
  const settings = {
    ...props.mapModule.reactiveData.requestSettings,
    regionId: props.regionId,
  };
  return props.mapModule.moduleConfig.serviceBaseUrl + "/districts.geojson?settings=" + encodeURIComponent(JSON.stringify(settings));
});

const { data: districtsData, isLoading } = useSmartFetch<IkmGeoJsonResponse>(districtsUrl);

const isLoadingDelayed = useDelayedBoolean(isLoading, 250, 0);

const sortedDistricts = computed(() => {
  const features = districtsData.value?.features ?? [];
  return [...features].sort((a, b) =>
    (a.properties?.name ?? "").localeCompare(b.properties?.name ?? "", "de")
  );
});

onUnmounted(() => {
  props.mapModule.selectRegion(null, null);
});
</script>
